import * as React from 'react';
import * as styles from './WebpartIntro.css';
import { IAIcon } from '../icon/Icon';

export interface IWebpartIntroProps {
  text: string;
  icon: string;
  description?: string;
  className?:string;
  style?: React.CSSProperties;
  onChange: (text: string) => void;
}

export interface IWebpartIntroState {
  text: string;
}

export class IAWebpartIntro extends React.Component<IWebpartIntroProps, IWebpartIntroState> {

  constructor(props: IWebpartIntroProps) {
    super(props);
    this.state = {
      text: props.text
    };
    
  }

  public componentWillReceiveProps(props: IWebpartIntroProps): void {
    this.setState({ text: props.text });
  }


  public render(): JSX.Element {
    return (
      <div 
        className={styles.IA_webpartIntroWrapper}>
        <div className={styles.IA_webpartIntroContainer} style={this.props.style}>
          <div className={styles.IA_webpartIntroHeader}>
            <div className={styles.IA_webpartIntroIcon}>
            <IAIcon
                  title={this.props.icon}
                  size={43}
                  color="#333333"
                  style={{
                  display: "block",
                  marginLeft: "auto",
                  marginRight: "auto",
                  marginTop: "0px",
                  marginBottom: "0px",
                  textAlign: "center"
                }}/>
            </div>
            <div className={styles.IA_webpartIntroText}>{this.state.text}</div>
          </div>
          <div className={styles.IA_webpartIntroFooter}>
            <div className={styles.IA_webpartIntroDescription} title={this.props.description}>{this.props.description}</div>
            <div className={styles.IA_webpartIntraButton}>
            <button type="button">Add</button>
            </div>
          </div>
          </div>
      </div>
    );
  }
}